<template>
  <div>

    <div class="row">
      <div class="col-md-12">
        <promotion-form
          :data='data'
        />
      </div>
    </div>

    <div class="text-right">
      <btn-rounded
        label="SALVAR"
        event="save"
      />
    </div>

  </div>
</template>
<script>
  import PromotionForm from "components/UIComponents/Forms/PromotionForm.vue";
  import {mapActions} from "vuex";

  export default {
    components: {
      PromotionForm
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data() {
      return {
        data: {}
      };
    },
    created() {
      this.$on("save", () => {
        if (this.data.name != '') {
          this.createPromotion(this.data)
            .then(res => {
              this.$notify({
                group: "foo",
                title: "Sucesso",
                text: res.msg,
                position: "top center",
                type: "success"
              });
              this.data = {};
            })
            .catch(res => {
              this.$notify({
                group: "foo",
                title: res.msg,
                text: res.info,
                position: "top center",
                type: "error"
              });            });
        } else {
          alert("Nome inválida")
        }
      });
    },

    mounted() {
      this.data = !this.$route.params.model ? {} : this.$route.params.model;
    },
    methods: {
      ...mapActions(["createPromotion"]),

    }
  };
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Promotion/PromotionCreate.vue